import { buttons } from "@icarros/theme-react";
export const { sizes, types } = buttons;
export var IconButtonVariants;
(function (IconButtonVariants) {
    IconButtonVariants["neutral"] = "neutral";
    IconButtonVariants["primary"] = "primary";
    IconButtonVariants["secondary"] = "secondary";
})(IconButtonVariants || (IconButtonVariants = {}));
export var IconButtonWeights;
(function (IconButtonWeights) {
    IconButtonWeights["small"] = "small";
    IconButtonWeights["medium"] = "medium";
})(IconButtonWeights || (IconButtonWeights = {}));
//# sourceMappingURL=constants.js.map